import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import hu_dc from "./translations/hu.json"
import en_dc from "./translations/en.json"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    lng: "hu",
    fallbackLng: "hu",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      hu: {
        translation: hu_dc,
      },
      en: {
        translation: en_dc,
      },
    },
  })

export default i18n
